import { Component, h } from 'preact';
import * as appStyles from '../../assets/global.scss';
import { WithStyles, withStyles } from '../../style';
import { Column } from '../Layout/Layout';
import { Properties } from '../types';
import { stopPropagation } from '../../utils';
import { getKey, Key } from '../../common';
import * as styles from './Selector.scss';

interface SelectorProps extends Properties {
  disabled?: boolean;
}

type EffectiveProps = SelectorProps & WithStyles;

@withStyles(styles, appStyles)
export default class Selector extends Component<SelectorProps> {
  handleKeyDown = (e: KeyboardEvent) => {
    const key: Key = getKey(e);
    if (key === Key.SPACE) {
      stopPropagation(e);
    }
  };

  render({ tx, disabled, children, ...attr }: EffectiveProps) {
    return (
      <Column
        {...attr}
        class={tx(this.props.class, 'cursor-pointer', {
          disabled,
          'focus-inset': !disabled,
        })}
        tabIndex={disabled ? -1 : 0}
        role="button"
        aria-disabled={disabled}
        onKeyDown={this.handleKeyDown}
      >
        {children}
      </Column>
    );
  }
}
